import React from 'react';
export function Footer() {
  return <footer className="bg-black text-gray-500 py-4 md:py-8 text-center text-sm border-t border-gray-900" data-id="element-175">
      <div className="max-w-7xl mx-auto px-4" data-id="element-176">
        <p className="mb-2" data-id="element-177">© Biblia Visual — Todos Los Derechos Reservados</p>
        <p data-id="element-178">Producto digital con acceso inmediato tras el pago.</p>
      </div>
    </footer>;
}